/**
 * Created by TzuHsing on 2020-09-10
 */
export const YESTERDAY = '1'
export const TODAY = '2'
export const LAST_MONTH = '3'
export const THIS_MONTH = '4'
export const LAST_YEAR = '5'
export const THIS_YEAR = '6'
export const BEFORE_DAY = '7' // 前一天
export const NEXT_DAY = '8' // 下一日
export const NO_DISCOUNT = 1 //无折扣

export const CHANGE_TYPE = {
  INFO_TYPE: 1, // 资料
  LEVEL_TYPE: 2, // 折扣等级
  WALLET_TYPE: 3, // 钱包
  DIAMOND_TYPE: 4, // 钻石
  PRACTICE_TYPE: 5, // 练球卡
  DIALOGUE_TYPE: 6, // 对话
  FOOTPRINT_TYPE: 7, // 足迹
}



// WEBPACK FOOTER //
// ./src/util/const.js